import React from "react";
import styled from "styled-components";
import Colors from "../../ui/global/Colors";
import Fonts from "../../ui/global/Fonts";
import ButtonLink from "../../ui/components/ButtonLink";
import Logo from "../../ui/components/Logo";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { getWebsiteUrl } from "../../utils/urls";

const FooterContainer = styled.footer<{ $colorMode: 'light' | 'dark' }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 8px;
    padding: 8px 0;
    z-index: 100;
    flex-shrink: 0;
`;

const Nav = styled.nav`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const LinkList = styled.ul`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    list-style: none;
    padding: 0;
    margin: 0;
`;

const LogoWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-right: 8px;
    cursor: pointer;
`;

interface FooterProps {
    page: 'games' | 'art' | 'animation';
    colorMode?: 'light' | 'dark';
    onLogoClick?: () => void;
}

const Footer: React.FC<FooterProps> = ({ page, colorMode = 'dark', onLogoClick }) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const scrollToTop = () => {
        // console.log("Scrolling to top...");
        if (onLogoClick) {
            onLogoClick();
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const onClick = (path: string) => {
        // navigate(path);
        // console.log(`Navigating to: ${path}`);
        window.open(path, '_blank');
    };

    const onFAQClick = () => {
        const url = getWebsiteUrl(`/faq-${page}`);
        window.open(url, '_blank');
    };

    return (
        <FooterContainer $colorMode={colorMode}>
            <Nav aria-label="Footer Navigation">
                <LinkList>
                    {isMobile && (
                        <li>
                            <ButtonLink 
                                size="small"
                                color={colorMode === 'dark' ? 'white' : 'black'}
                                text="Pricing"
                                onClick={() => onClick('/pricing')}
                            />
                        </li>
                    )}
                    <li>
                        <ButtonLink 
                            size="small"
                            color={colorMode === 'dark' ? 'white' : 'black'}
                            text="FAQ"
                            onClick={onFAQClick}
                        />
                    </li>
                    <li>
                        <ButtonLink 
                            size="small"
                            color="grey"
                            text="Terms"
                            onClick={() => onClick('/terms-of-service')}
                        />
                    </li>
                    <li>
                        <ButtonLink 
                            size="small"
                            color="grey"
                            text="Privacy"
                            onClick={() => onClick('/privacy-policy')}
                        />
                    </li>
                </LinkList>

                <LogoWrapper>
                    <ButtonLink 
                        size="small"
                        color={colorMode === 'dark' ? 'white' : 'black'}
                        text="Mascots"
                        onClick={() => onClick('https://ziggle.art')}
                    />
                    <Logo 
                        colorMode={colorMode} 
                        text={isMobile ? null : "left"} 
                        caps={true}
                        size={14} 
                        onClick={scrollToTop}
                    />
                </LogoWrapper>
            </Nav>
        </FooterContainer>
    );
};

export default Footer;